import { jsonDeserialize } from '@palador/json';
import { AiScrubBatchAcceptedResponse } from '../../models/ai-scrub-batch-accepted-response';
import { AiScrubBatchConflictError } from '../../models/ai-scrub-batch-conflict-error';
import { AiScrubBatchEmptyError } from '../../models/ai-scrub-batch-empty-error';
import { AiScrubScope } from '../../models/ai-scrub-scope';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const startAiScrubBatch: (
  fetchContext: FetchContext,
  awardId: number,
  rubricPrompt: string,
  accessToken?: string,
  scope?: AiScrubScope,
  countryId?: number,
) => Promise<AiScrubBatchAcceptedResponse> = (fetchContext, awardId, rubricPrompt, accessToken, scope = 'awards', countryId) =>
  fetch(`${fetchContext.baseUrl}/api/staff/${scope}/${awardId}/ai-scrub-batch`, {
    method: 'POST',
    body: JSON.stringify({ rubricPrompt, ...(countryId != null ? { countryId } : {}) }),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then(async (response) => {
    if (response.status === 409) {
      const conflict = jsonDeserialize<AiScrubBatchAcceptedResponse>(await response.clone().text());
      if (conflict?.batchRunId) {
        return Promise.reject<AiScrubBatchAcceptedResponse>({
          kind: 'ai-scrub-batch-conflict',
          batchRunId: conflict.batchRunId,
        } satisfies AiScrubBatchConflictError);
      }
    }
    if (response.status === 422) {
      return Promise.reject<AiScrubBatchAcceptedResponse>({
        kind: 'ai-scrub-batch-empty',
      } satisfies AiScrubBatchEmptyError);
    }
    return responseErrorHandler<AiScrubBatchAcceptedResponse>(fetchContext.errorStore, response, 'start AI scrub batch');
  });
